<template>
  <div>
  <b-card>

    <div class="loading_page" v-if="loading">
      <orbit-spinner
          :animation-duration="1000"
          :size="100"
          :color="'#0e96b1'"
      />
    </div>

    <b-tabs vertical content-class="col-12 col-md-9 mt-1 mt-md-0" pills
        nav-wrapper-class="col-md-2 col-12 border rounded p-1" nav-class="nav-left">

      <!-- Tab: information -->
      <b-tab active @click="currentTab = 'info'">
        <template #title>
          <feather-icon icon="InfoIcon" size="16" class="mr-0 mr-sm-50"/>
          <span class="d-none d-sm-inline">{{ $t('Information') }}</span>
        </template>
        <information-tab></information-tab>
      </b-tab>

      <!-- Tab: map -->
      <b-tab lazy @click="currentTab = 'map'">
        <template #title>
          <feather-icon icon="MapIcon" size="16" class="mr-0 mr-sm-50"/>
          <span class="d-none d-sm-inline">{{ $t('Map') }}</span>
        </template>

        <map-tab></map-tab>

      </b-tab>

      <!-- Tab: attributes -->
      <b-tab lazy @click="currentTab = 'attributes'" >
        <template #title>
          <feather-icon icon="CheckSquareIcon" size="16" class="mr-0 mr-sm-50"/>
          <span class="d-none d-sm-inline">{{ $t('Attribute') }}</span>
        </template>
        <geofence-attribute-tab></geofence-attribute-tab>
      </b-tab>


      <!-- Tab: association with devices -->
      <b-tab lazy @click="currentTab = 'association'">
        <template #title>
          <feather-icon icon="LinkIcon" size="16" class="mr-0 mr-sm-50"/>
          <span class="d-none d-sm-inline">{{ $t('Device Association') }}</span>
        </template>

        <devices-association-tab></devices-association-tab>
      </b-tab>


      <!-- Action Buttons -->
      <b-button v-if="currentTab !== 'association'"
          type="submit"
          variant="primary"
          class="mb-1 mb-sm-0 mr-0 mr-sm-1 mt-2"
          :block="$store.getters['app/currentBreakPoint'] === 'xs'"
          @click="updateGeofence"
      >
        {{ $t('Save Changes')}}
      </b-button>

    </b-tabs>
  </b-card>
  <b-row>
      <b-col cols="12" class="mt-5">
        <b-card no-body class="mb-0">
        <b-row>
          <b-col  cols="4">
            <CollapseableTimeLine  :params="{commentable:'geofence',commentable_id:$route.params.id}"  class="mt-5"/>
          </b-col>
        </b-row>
        </b-card>
      
     </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BTab, BTabs, BCard, BAlert, BLink, BButton,BRow,BCol
} from 'bootstrap-vue'
import { ref, onUnmounted, computed } from '@vue/composition-api'
import store from '@/store'
import { OrbitSpinner } from 'epic-spinners'
import InformationTab from '@/views/modules/geofence/geofence-create/InformationTab'
import MapTab from '@/views/modules/geofence/geofence-create/MapTab'
import GeofenceAttributeTab from '@/views/modules/geofence/geofence-create/GeofenceAttributeTab'
import DevicesAssociationTab from '@/views/modules/geofence/geofence-edit/DevicesAssociationTab'
import router from '@/router'
import { GeofenceStore } from '@/app/geofence/state'
import CollapseableTimeLine from '@core/components/app-timeline/CollapseableTimeLine.vue'
export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BButton,
    BAlert,DevicesAssociationTab,
    OrbitSpinner,
    InformationTab,GeofenceAttributeTab,
    MapTab,
    BLink,BRow,
    CollapseableTimeLine,
    BCol
  },
  setup(props, { root }) {

    const auth = store.state.auth.userData
    const GEOFENCE_STORE = 'geofence'

    const currentTab = ref('info')


    if (!store.hasModule(GEOFENCE_STORE))
      store.registerModule(GEOFENCE_STORE, GeofenceStore)

    onUnmounted(() => {
      store.commit('geofence/INIT_STATE')
      if (store.hasModule(GEOFENCE_STORE))
        store.unregisterModule(GEOFENCE_STORE)
    })

    store.commit('geofence/updateRoot', root)

    store.dispatch(
        'geofence/fetchGeofenceData',
        router.currentRoute.params.id
    )

    store.dispatch(
        'geofence/fetchLists',
        auth.id
    )



    const loading = computed(() => store.state.geofence.loading)
    const geofenceData = computed(() => store.state.geofence.data)

    const updateGeofence = () => {
      store.dispatch('geofence/updateGeofence').then(res => {
        root.$bvToast.toast(
            root.$i18n.t("geofence updated successfully"), {
              title: `Success`,
              variant: 'success',
            })
      }).catch(reason => {

        if (reason.status === 422) {
          root.$bvToast.toast(
              root.$i18n.t(reason.data.message), {
                title: `Validation Error`,
                variant: 'danger',
              })
        }
      })
    }

    return {
      updateGeofence,
      loading,
      geofenceData,
      currentTab,
    }
  },
}
</script>

<style>

</style>
